import DealerLayout from "./DealerLayout";

export default DealerLayout;
